module.exports = __webpack_public_path__ + "static/media/strikon.9216a460.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/strategy/data/strikon.png
// module id = 38
// module chunks = 0